module.exports = __webpack_public_path__ + "static/media/likedIcon.26ec1b1f.svg";